export const styleMenuBarDefault = {
  width:"100vw",
  minHeight:"9vh",
  color:"#fff",
  backgroundColor:"#5a516100",
  // boxShadow: "0.6vmin 0.6vmin 2.16vmin #000",
  // borderRadius: "0.6vmin",
  fontSize:"4.5vmin",
}

export const styleMenuBarInScroll = {
  width:"100vw",
  minHeight:"6.3vh",
  // justifyContent:"flex-start",
  color:"#fff",
  backgroundColor:"#411a75",
  boxShadow: "0.0vmin 0.6vmin 2.16vmin #000",
  borderRadius: "0vmin",
  fontSize:"2.7vmin",
}


// ------- Style Logo component

export const styleLogoDefault = {
  width: "6.3vmin",
  height:"6.3vmin",
  margin: "0.18vh  0.9vw",
  // boxShadow: "0.6vmin 0.6vmin 1.8vmin #000"
}

export const styleLogoInScroll = {
  width: "5.4vmin",
  height:"5.4vmin",
  borderRadius: "2.7vmin",
  // border: "0.18vmin solid #000",
  margin: "0.9vh  0.36vw",
  backgroundColor:"#fff",
  animation: "rotate 63s linear infinite",
  boxShadow: "0vmin 0vmin 0.45vmin  #fff"
}


// ------------- Style LogoTipo Component 

export const styleLogoTipoDefault ={
  first: {
    fontSize:"4.5vmin",
    color:"#000",
    fontWeight: 700,
  },content:{
    fontSize:"3.6vmin",
    color:"#000",
    textDecoration:"underline",
    fontWeight: 700,
  }
}
export const styleLogoTipoInScroll ={
  first: {
    fontSize:"4.5vmin",
    color:"#fff",
    textDecoration:"underline",
    fontWeight: 700,

  },content:{
    fontSize:"0vmin",
    color:"#fff"
  }
}

// ------- ItemLinkMenu 

export const ItemLinkMenuDefault = {
  hover:{
    backgroundColor:" #411a75",
  },a:{
    color:"#000",
  }
}
export const ItemLinkMenuInScroll = {
  hover:{
    // backgroundColor:" #6d18a2",
    backgroundColor:"blueviolet",
    padding:"1.26vmin 1.26vmin",
    margin: "0vh 0.9vw",
    transform: "scale(1)",
    boxShadow:"none"
  },a:{
    color:"#fff",
  }
}